import { useEffect, useState, useRef } from "react";
import { useLocation } from "wouter";
import { gradient, textGradient, COLOR } from "../common/css/colors";

import { put } from "../common/net/requester";
import { Button } from "../components";

import "../styles/verify.css";

const Verify = () => {
    const [, setLocation] = useLocation();
    const [code, setCode] = useState("");
    const [email, setEmail] = useState("");

    const [d1, setD1] = useState("");
    const [d2, setD2] = useState("");
    const [d3, setD3] = useState("");
    const [d4, setD4] = useState("");
    const [d5, setD5] = useState("");
    const [d6, setD6] = useState("");

    const entryRefs = useRef<Record<string, HTMLInputElement>>({});

    const _handleCodeChange = (
        i: number,
        val: string,
        setVal: (x: string) => void,
    ) => {
        if (/[^\d]/.test(val) || val.length > 1) {
            return;
        }

        setVal(val);

        if (entryRefs.current[`${i + 1}`]) {
            entryRefs.current[`${i + 1}`].focus();
        }
    };

    const codeSubmit = () => {
        if (email.length === 0) return; // TODO: error toast?

        put<{ accessToken: string; refreshToken: string }>("/auth/action", {
            email,
            code,
        })
            .then((res) => {
                if (!res.ok) {
                    console.log(res.status, res.message);
                    return;
                }

                localStorage.setItem("refreshToken", res.body.refreshToken);
                sessionStorage.setItem("accessToken", res.body.accessToken);
                setLocation("/questlog");
            })
            .catch((err) => console.error("fail to code submit:", err));
    };

    useEffect(() => {
        const queryParams = new URL(window.location.toString()).searchParams;

        const email = queryParams.get("email");
        if (email) {
            setEmail(email);
        } else {
            setLocation("/signup");
        }
    }, [setLocation]);

    useEffect(() => {
        if (
            d1.length &&
            d2.length &&
            d3.length &&
            d4.length &&
            d5.length &&
            d6.length
        ) {
            setCode(`${d1}${d2}${d3}${d4}${d5}${d6}`);
        } else {
            setCode("");
        }
    }, [d1, d2, d3, d4, d5, d6]);

    return (
        <div className="routeParent">
            <div className="routeInner">
                <a
                    className="signupQuestieHeader"
                    href="/"
                    style={{ textDecoration: "none" }}
                >
                    <h1
                        style={{
                            ...textGradient(COLOR.teal3, COLOR.lime3),
                            userSelect: "none",
                        }}
                    >
                        questie
                    </h1>
                </a>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "1em",
                    }}
                >
                    <h3>You know the drill, check your email</h3>
                    <div>
                        <DigitEntry
                            val={d1}
                            setVal={setD1}
                            setAndFocus={(val) =>
                                _handleCodeChange(1, val, setD1)
                            }
                            setRef={(x) => (entryRefs.current["1"] = x)}
                        />

                        <DigitEntry
                            val={d2}
                            setVal={setD2}
                            setAndFocus={(val) =>
                                _handleCodeChange(2, val, setD2)
                            }
                            setRef={(x) => (entryRefs.current["2"] = x)}
                        />

                        <DigitEntry
                            val={d3}
                            setVal={setD3}
                            setAndFocus={(val) =>
                                _handleCodeChange(3, val, setD3)
                            }
                            setRef={(x) => (entryRefs.current["3"] = x)}
                        />

                        <DigitEntry
                            val={d4}
                            setVal={setD4}
                            setAndFocus={(val) =>
                                _handleCodeChange(4, val, setD4)
                            }
                            setRef={(x) => (entryRefs.current["4"] = x)}
                        />

                        <DigitEntry
                            val={d5}
                            setVal={setD5}
                            setAndFocus={(val) =>
                                _handleCodeChange(5, val, setD5)
                            }
                            setRef={(x) => (entryRefs.current["5"] = x)}
                        />

                        <DigitEntry
                            val={d6}
                            setVal={setD6}
                            setAndFocus={(val) =>
                                _handleCodeChange(6, val, setD6)
                            }
                            setRef={(x) => (entryRefs.current["6"] = x)}
                        />
                    </div>

                    <Button
                        text="Submit"
                        disabled={code.length !== 6}
                        background={
                            gradient(COLOR.orange, COLOR.peach4, 45).background
                        }
                        onClick={codeSubmit}
                    />
                </div>
            </div>
        </div>
    );
};

const DigitEntry = ({
    val,
    setVal,
    setAndFocus,
    setRef,
}: {
    val: string;
    setVal: React.Dispatch<React.SetStateAction<string>>;
    setAndFocus: (x: string) => void;
    setRef: (x: HTMLInputElement) => void;
}) => {
    return (
        <input
            ref={(ref) => ref && setRef(ref)}
            style={{
                color: "black",
                fontSize: "24px",
                width: "24px",
                textAlign: "center",
            }}
            type="text"
            maxLength={1}
            value={val}
            onFocus={() => setVal("")}
            onChange={(e) => setAndFocus(e.target.value)}
        />
    );
};

export default Verify;
